module.exports = __webpack_public_path__ + "img/workplace.28f14850.png";